import { createContext } from 'react';

export const VendaContext = createContext({
  venda: {
    cliente: null,
    itens: [],
    itensExcluidos: [],
    subTotal: 0,
  },
  dispatch: () => {},
});
